import {Phone as PhoneIcon, Person as PersonIcon, Place as PlaceIcon, Work as WorkIcon} from '@mui/icons-material';
import { Link as A } from '@mui/material';
import '../../../css/person.css';
import Flex from '../../Tools/Flex';
import StudentProof from './StudentProof';

export default function Cards({person}){

    return <Flex >

        <Card title="Profil" ico={<PersonIcon />}>
            Filière {person.category?.title}
            <br/>
            Statut {person.status?.title || <span>Non renseigné</span>}
            <br/>
            RPPS : {person.rpps || <span>Non renseigné</span>}
            <br/>
            Provenance : {person.origin?.title} {person.origin?.comment ? `(${person.origin?.comment})` : ''}
            <br/>
            Abonnement : {person.subscription?.title}
            <br />
            <StudentProof user={person} />
        </Card>

        <Card title="Adresse" ico={<PlaceIcon />}>
            {person.address}<br/>
            {person.zip}<br/>
            {person.city} {person.city ? (' (' + person.country + ')') : ''}
        </Card>

        <Card title="Contact" ico={<PhoneIcon />}>
            <div className="mrg-b5">
                <A href={'mailto:' + person.email}>{person.email}</A>
            </div>
            {person.phone 
                ? <A href={'tel:' + person.phone}>{person.phone}</A>
                : <span>Non renseigné</span>
            }
            <br/>
            {person.phone2 &&
                <A href={'tel:' + person.phone2}>{person.phone2}</A>
            }
        </Card>

        <Card title="Entreprise" ico={<WorkIcon />}>
            SIRET : {person.siret || <span>Non renseigné</span>}
            <br/>
            Organisation : {person.company?.name || <span>Non renseignée</span>}
            <br/>
            Type : {person.company?.type?.title || <span>Non renseigné</span>}
            <br/>
            Maison mère : {person.group?.name || <span>Aucune</span>}
            <br/>
            Effectif : {person.workforce || 0}
        </Card>

    </Flex>
}




function Card({ico, title, children}){

    return <div className="person-card">

        <div className="person-card-title">
            {ico}
            <span>{title}</span>
        </div>
        
        <div className="person-card-content">
            <span>{children}</span>
        </div>

    </div>
}